import React, { useState, useEffect } from 'react';

const DateGreeting = () => {
  const dateTime = new Date();

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long', // Monday
      year: 'numeric', // 2024
      month: 'long', // August
      day: 'numeric', // 26
    });
  };

  return (
    <div className='mb-20'>
      <h3>{formatDate(dateTime)}</h3>
    </div>
  );
};

export default DateGreeting;